import { useState, useEffect } from 'react';
import './App.css';
import LoginScreen from './screens/LoginScreen';
import ContentScreen from './screens/ContentScreen';
import PuzzleScreen from './screens/PuzzleScreen';
import HangmanScreen from './screens/HangmanScreen';
import TriviaScreen from './screens/TriviaScreen';
import CarouselScreen from './screens/CarouselScreen';

// ─── Image imports ────────────────────────────────────────────────────────────
import undieslogo from './images/undieslogo.png';
import guy from './images/drbuttsnatch.png';
import cmdrbriefs from './images/cmdrbriefs.png';
import cmdrbdrat from './images/cmdrbdrat.png';
import cmdrbout from './images/cmdrbout.png';
import schematic from './images/schematic.png';
import angry from './images/drbs_angry.png';
import bootybase from './images/bootybase.png';
import mrswiggity from './images/mrswiggityswooty.png';
import zombiesdefeated from './images/zombiesdefeated.png';
import drawing from './images/drawing.png';
import smashedsplashed from './images/smashedsplashed.png';
import drbs_movies from './images/drbs_movies.png';
import buttonomicon from './images/buttonomicon.png';
import cryptex from './images/cryptex.png';
import arcaderitual from './images/arcaderitual.png';


import hangman1 from './images/hangman1.png';
import hangman2 from './images/hangman2.png';
import hangman3 from './images/hangman3.png';
import hangman4 from './images/hangman4.png';
import hangman5 from './images/hangman5.png';
import hangman6 from './images/hangman6.png';
import hangman7 from './images/hangman7.png';

import carousel1 from './images/carousel/1.JPG';
import carousel2 from './images/carousel/2.JPG';
import carousel3 from './images/carousel/3.jpg';
import carousel4 from './images/carousel/4.jpg';
import carousel5 from './images/carousel/5.jpg';
import carousel6 from './images/carousel/6.jpg';
import carousel7 from './images/carousel/7.jpg';
import carousel8 from './images/carousel/8.jpg';
import carousel9 from './images/carousel/9.jpg';

// ─── Screen config ────────────────────────────────────────────────────────────
// Each entry is one screen. Index N-1 = user-facing screen number N.
//
// Screen types:
//   'content'    — static screen, same for both users
//   'content-ab' — static screen, A/B keys hold per-user { heading, blocks }
//   'puzzle'     — answer-gated screen, same for both users
//   'puzzle-ab'  — answer-gated screen, A/B keys hold per-user { question, correctAnswer, blocks }
//
// Optional 'blocks' array (content and puzzle screens, or inside A/B for ab variants):
//   { type: 'text',  value: 'paragraph text here' }
//   { type: 'image', src: importedImage, alt: 'description' }
// Blocks render in order between the heading and the question/nav area.

const MSG_UNDIES_INTRO = 'Croteau-McDaniels household, you’re needed for an urgent mission! Gather your adventuring supplies, we’re sending our Second-best Agent Mobilizers (or SAMs) to pick you up. \n\n' +
    'When they arrive, they\'ll give you the top-secret passphrase needed to continue.\n\n-Commander Briefs';
const MSG_WELCOME = 'The world faces a dire crisis and needs your help. The nefarious Dr. Bibidious Buttsnatch has concocted a new scheme to steal everyone in the world’s butts, and only you, our top agents, can stop him.\n\n' +
    'Prepare to face off with Dr. Buttsnatch while you work on tracking him down to figure out his next move!\n\nAs usual, I will be providing moral and tactical support from the safety of my office.\n\nSincerely,\nCommander Briefs';
const MSG_PZL_3A = "Dr. Buttsnatch has gone on the run, and you must find him to foil his perilous pantsery. We sent agents to his last known location, and all we could find is this mysterious and potentially evil riddle. We think it divulges Dr. Buttsnatch’s next destination. What can you make of it?"
const MSG_PZL_3A_CLUE = "Not all things are as they appear\nTwo words combined can squeeze into one\nQueens in their court can seem rather queer\nAnd what’s needed to live can also be fun\n"
const MSG_PZL_3B = "This isn’t a mission you want to go rushing into with your cheeks flapping in the breeze - you need to prepare. Take this time to level up your battle skills using our Hyper Realistic Battle Simulator.\n\nBe warned - the Hyper Realistic Battle Simulator is no walk in the park. I’ve seen grown men shart their shorts trying to complete it. Try to score at least 25 kills in the Hyper Realistic Battle Simulator before reaching the next destination. When ready, inform your SAMs team to receive the next access code."
const MSG_CONT_3_5 = "Great job picking up the trail and completing your training arc, agents. Once you catch up to Dr. Buttsnatch, let us know your location, and we will debrief you on what we've learned on our (rear) end.\n\nWarmly Yours,\nCommander Briefs";
const MSG_CONT_4_MACHINE = "You just missed Dr. Buttsnatch at brunch! But it appears he's been building a vile machine to snatch up everyone in the world’s butts and build a giant butt palace! Our scientists have learned that the machine has only two weaknesses. They have not learned what those weaknesses are. (They are only mediocre scientists.)"
const MSG_CONT_4_MACHINE1 = "It's time to divide and conquer. Each of you will need to discover one of the machine's weaknesses so that we can stop this plan in its tracks! We eagerly await your conclusions.\n\nWith My Undying Gratitude,\nCommander Briefs";
const MSG_PZL_5A = "The evil doctor has hidden one of his machine's vital weaknesses inside this crossword puzzle that would be utterly impenetrable to anyone who hasn't spent extensive time with the Styx & Stones. Agent Sarah, we need your help!";
const MSG_PZL_5B = "The evil doctor has hidden one of his machine's vital weaknesses behind a wall of trivia and riddles that would be utterly impenetrable to anyone who doesn't know a bunch of random information and interesting facts. Agent Chanceantha, we need your help!";
const MSG_PZL_5_3 = "Excellent, you've uncovered one of the techniques needed to destroy the Gluteus Grabber for good. Your co-agent should be isolating the other as we speak. Once you've both completed your investigations, send us your full report below.\n\nMy Sincerest Adoration,\nCommander B.";
const MSG_CONT_5_5 = "Tremendous espionaging! You figured out the only two weaknesses of Dr. Buttsnatch's machine! We would never have guessed that:\n\n1. The machine is susceptible to neon paint being splashed at or around it...\n2. It turns out the machine is also vulnerable to being smashed.\n\nIn other words, you'll have to SMASH and SPLASH to destroy it. Now get out there! Let us know when the deed is done.\n\nxoxo,\nCommander Briefs";
const MSG_CONT_6_DRBS1 = "NOOOOO, you’ve destroyed my beautiful buttsnatching machine that I was going to use to steal everyone in the world’s butts for sports! Well, not to worry, I still have a few tricks up my briefs... and you’ll never stop me this time!\n\n - Dr. B. Buttsnatch"
const MSG_CONT_7_HQ = "Great work, team. We're sending you to Hindquarters Headquarters to debrief and regroup, while we send samples from what's left over of his machine back to the lab for processing. Our scientists will try to piece together Bibidious' next move, but you know how they are \u{1F644}\n\nCheck in with the SAMs when you're ready for your next directive.\n\nWith Love,\nCommander Briefs"
const MSG_CONT_9_BASE = "Dr. Buttsnatch hasn’t been defeated yet. He’s still planning to steal everyone in the world’s butts and bounce around on them a bunch.\n\nHe's retreated to his Top Secret Booty Base, but our top U.N.D.I.E.S. scientists haven't been able to locate that yet. They need your help again, clearly.\n\nYou'll have to split up, see what you can each find out, and then put your information together to find the Top Secret Booty Base."
const MSG_PZL_10A = "Agent Sarah: This cryptex has stumped even our best puzzle-solvers. Three of them quit in a rage after working on it. One was sent to the hospital. Two more disappeared to a remote island, and were so traumatized they have refused to re-enter society. You're our only hope of cracking it.\n\nWe've confirmed that the cryptex contains a clue hidden inside.\n\nOnce you've revealed your clue, combine it with Agent Chance's clue to uncover what they mean."
const MSG_PZL_10B = "You think I’m just going to tell you everything I know about the location of Dr. Buttsnatch’s Top Secret Booty Base? I’d never do that, unless of course you can beat me in a special game.\n\nIt’s played like HORSE, except you won’t know what word you’re playing for. Muahaha."
const MSG_PZL_10B2 = "Here's how it works.\n\nFor each shot you make and I miss, you’ll successfully reveal one letter of your clue.\nFor each shot I make and you miss, you’ll get spanked with one letter of my name.\n\nIf you get my whole name before your whole clue, I will own your soul and butt forever. It’s basically like Space Jam, or Air Bud. By the way, I forgot to introduce myself. My name is:\n\n MR SWIGGITY SWOOTY BOOTY"
const MSG_CONT_11_MOVIES = "**Le Gasp!** You're right! The Top Secret Booty Base must be at the movies.\n\nIt all makes sense now... that's why he leaves so many movie ticket stubs wherever he goes.\n\nThe U.N.D.I.E.S. procurement team has gotten you tickets to a random movie. You'll need to go undercover as regular movie-goers and try to catch Dr. Buttsnatch while you're there. Heads up: If you don't get snacks, it could blow the whole operation.\n\nWishing I Was On A Movie Date With You,\nCommander Briefs"
const MSG_CONT_12_ZOMBIES = "Aw crap! Aw farts! You did a great job sneaking into the Top Secret Booty Base, but it turns out the SAM agents we sent with you are terrible at being stealthy. They made a big ruckus and tipped off Dr. Buttsnatch."
const MSG_CONT_12_ZOMBIES1 = "The bad news is: He fled. And to cover his escape, he launched a horde of Butt Zombies to attack Hindquarters Headquarters!\n\nThe good news is: While he was fleeing, we heard him yelling 'heehee hohoho, you'll never find my Butt-O-Nomicon! You idiots!' so at least we know what to look for next.\n\nYou'll have to split up to deal with the threat and the research simultaneously."
const MSG_CONT_12A_RELAXA = "Agent Sarah: Since Dr. Buttsnatch was yelling about this so-called Butt-O-Nomicon, we figure that's the next key to his evil plan. But we have no idea what it is... or what it does.\n\nWhile Agent Chance fights off the Butt Zombies, we need you to go on a research mission. Teach us all you can discover about the Butt-O-Nomicon, how Dr. Buttsnatch plans to use it, and how it can be stopped."
const MSG_CONT_12B_RELAXB = "Agent Chance, handling the zombie threat rests entirely on your conspicuously broad shoulders.\n\nHow you handle them is your choice. It's time to decide on a strategy."
const MSG_PZL_13B = "A sea of butt-hungry monsters are headed straight for Hindquarters Headquarters.\n\nHow to handle them is up to you. You can either race back to defend HQ (Special Chance Relaxation Hour\u{2122}), or attack the zombies head-on (go to an arcade or something).\n\nHow will you quell the zombie threat? Will you ATTACK or DEFEND? Inform your nearest SAM agent, and they will follow you into battle."
const MSG_CONT_14A_REGROUPA = "After you destroyed his machine, of course Dr. Buttsnatch would turn to a book of buttomancy magic. When sci-fi failed him, he pivoted to fantasy. He must have stolen the Butt-O-Nomicon book from the woodland witches. Great job finding this information!\n\nWe recevied word that Agent Chanceantha has defeated the butt zombie horde, so it's safe to go back to Hindquarters Headquarters for a rest and recoup. You've earned it.\n\nWe'll send our scientists to find out where he's hiding the book, and contact you soon with your next directive. I am sure they won't poop out on this one.\n\nThoughts & Prayers,\nCommander B."
const MSG_CONT_14B_REGROUPB = "You defeated the butt zombies! You are butt-orious! Thank you for protecting Hindquarters Headquarters. It's time to regroup and recoup with your team. We'll contact you soon with your next directive."
const MSG_CONT_14_5_HANGMAN = "Our U.N.D.I.E.S. scientists uncovered a hint about where Dr. Buttsnatch hid the Butt-O-Nomicon. He accidentally left this odd drawing behind when he was fleeing from the Top Secret Booty Base in a hurry…\n\nOf course, our scientists have no idea how to decipher it. Surprise, surprise. That's what we get for shopping for bargain-bin scientists.\n\nCan you help us decode it?"
const MSG_CONT_16_TODINNER = "Blast it all! Darn toot it all! We got trolled by Dr. Buttsnatch! Of course he wouldn’t reveal his plans in a hangman-style game, no matter how hilarious the artwork was. That's way too obvious.\n\nWell, that lead was a total butt bust.\n\nYet, all is not lost! You will be surprised to hear that our scientists were actually useful for once. While cleaning up popcorn at the Top Secret Booty Base, one of them tripped and stumbled upon the exact location where Dr. Buttsnatch hid the Butt-O-Nomicon book.\n\nI know, even broken clocks, right?\n\nWe're sending over the coordinates to your Second-best Agent Mobilizers now. Let us know when you get there.\n\nSmooches and num-nums,\nCommander Briefs"
const MSG_PZL_17A = "Agent Sarah: You did it! You tracked down the legendary Butt-O-Nomicon tome, which Bibidious hid at this restaurant for some reason. You now hold in your hands an ancient text full of long-forgotten butt magicks of the good, evil, and woodland varieties. We are so close to getting him once and for all, I can feel it in my glutes!\n\nStudy the ancient text and see if you can make sense of how the magic evil buttomancy ritual works... and most of all, if you can discern where Dr. Buttsnatch is planning to perform it.\n\nWe suspect he'll try to complete the ritual tonight, and if we have our way, you and Agent Chance will be there to interrupt him before he can finish the spell."
const MSG_PZL_17B = "It all comes down to this, there's no time for holding back! Soon, you'll head to the climactic final battle with the depraved Dr. Buttsnatch to stop him from stealing everyone in the world's butts and motorboating them - disgusting.\n\nBefore you face him, you'll have to train harder than ever before to reach your final form. Step up to our newly developed Mega-Ultra Realistic Battle Simulator to complete your transformation."
const MSG_PZL_17B1 = "Buckle up buttercup, this new simulator makes the Hyper Realistic Battle Simulator your trained on earlier look like a mere child's plaything.\n\nOne last thing - it is absolutely imperative that, while training with the Mega-Ultra Realistic Battle Simulator, you provide your own comic book onomatopoeia battle sounds, like \"fuh, FUH,\" etc, or it won't work."
const MSG_CONT_18_TOARCADE = "Well done! This is why you're the best of the best. Now it's time to cover your butts, hold onto your butts, and get ready for a FINAL BOSS BUTT BATTLE with Dr. Buttsnatch at the arcade!\n\nBe sure to check in here afterwards - we'll want a full report to file in our filing cabinet. Here at U.N.D.I.E.S., we are very diligent about our filing cabinets."
const MSG_CONT_19_COOKIES = "You know what happens after you save the world? You get to have a little treat. The team here at the U.N.D.I.E.S. central office pooled together our lunch money to provide you with exactly (1.0) units of reward, each.\n\nWhen you are ready to collect your final reward, inform your accompanying SAMs agents, and they will take you to the... erm... rewards warehouse. Anytime until 1:00am, which is when I'm told they close.\n\nFrom all of us here at U.N.D.I.E.S., we send our sincerest buttfelt-thanks for saving our... asses."
const MSG_CONT_20_THANKS = "You did it, Styx family. You completed your quest, and if you had even half the fun doing it that we had making it, then it was all worth it.\n\nYou two have such a positive impact on so many people all around you, and this was our little way of trying to say thanks, and share a little bit of it back with you.\n\nThis friendship has been one of the most important things to us these past many years. Together, the good times are so much better, and the hard times are just a little bit easier to struggle through.\n\nWe are both grateful and proud to call you our family. We'll let you get back to your well-earned week off now, and then we look forward to many more silly adventures ahead.\n\nSee you back at HQ.\n\nLove always,\nYour Sams"

const SCREEN_CONFIG = [
  // screen 0  a message from UNDIES
  { type: 'puzzle', label: '0',
    heading: 'A Message From U.N.D.I.E.S.',
    blocks: [
      { type: 'image', src: undieslogo, alt: 'undies logo' },
      { type: 'text',  value: MSG_UNDIES_INTRO },
    ],
    question: 'Enter the passphrase below',
    correctAnswer: 'trumpets fanfare'
  },
  // screen 1 - “login”
  { type: 'login', label: '1' },
  // screen 2 - welcome
  { type: 'content', label: '2',
    heading: 'Mission Briefing',
    blocks: [
      { type: 'image', src: guy, alt: 'The guy' },
      { type: 'text',  value: MSG_WELCOME },
    ],
  },
  // screen 3 - first puzzle on the way to brunch
  { type: 'puzzle-ab', label: '3',
    A: {
      heading: 'I am a riddle. What am I?',
      blocks: [
        { type: 'text',  value: MSG_PZL_3A },
        { type: 'text',  value: MSG_PZL_3A_CLUE, className: 'handwritten-note' },
      ],
      question: 'Where should we go next?',
      correctAnswer: 'drag brunch' },
    B: {
      heading: 'It\'s a Training Arc!',
      blocks: [
        { type: 'text',  value: MSG_PZL_3B },
      ],
      question: 'Enter access code here:',
      correctAnswer: 'the iron butt'
    },
  },
  // screen 3.5  Codeword to resume the game at brunch
  { type: 'puzzle', label: '3_5',
    blocks: [
      { type: 'image', src: cmdrbriefs, alt: 'commander briefs' },
      { type: 'text',  value: MSG_CONT_3_5 },
    ],
    question: 'Once you arrive at Dr. Buttsnatch\'s last known location, enter its name here to proceed',
    correctAnswer: 'black sheep'
  },
  // screen 4  AtBrunch content
  { type: 'content', label: '4',
    heading: 'What the heck?!',
    blocks: [
      { type: 'text',  value: MSG_CONT_4_MACHINE },
      { type: 'image', src: schematic, alt: 'machine schematic' },
      { type: 'text',  value: MSG_CONT_4_MACHINE1 },
    ],
  },
  // screen 5  FromBrunch puzzle
  { type: 'puzzle-ab', label: '5',
    A: { 
      heading: 'Oh, you stupid, stupid bitch... You thought you wouldnt have to do a crossword today? Think again!',
      blocks: [
        { type: 'text',  value: MSG_PZL_5A },
        { type: 'link', href: 'https://crosswordlabs.com/view/sarahs-buttsnatch-crossword', label: 'A lil\' Puzz' }
      ],
      question: 'What word did the crossword reveal?', correctAnswer: 'splash' },
    B: {
      heading: 'Trivia Challenge',
      blocks: [
        { type: 'text',  value: MSG_PZL_5B },
      ],
      questions: [
        { label: 'Question 1', question: 'Mark Ruffalo replaced Ed Norton as the title character of the series after this 2008 MCU flop, an absolute stinker', correctAnswers: ['hulk', 'the hulk', 'the incredible hulk'] },
        { label: 'Question 2', question: 'The gourd that replaced turnips for a certain seasonal tradition when it migrated from Ireland to the US', correctAnswers: ['pumpkin', 'pumpkins'] },
        { label: 'Question 3', question: 'You\'ll commonly find one of these in a paper sack among several others, or alternatively, at Bob\'s' , correctAnswers: ['burger', 'burgers'] },
        { label: 'Question 4', question: 'Homophone for the style of workout routine employed in Shaun T\'s “Insanity”', correctAnswers: ['hit'] },
        { label: 'Question 5', question: 'Where I\'m going to grape you (look what you\'re wearing)', correctAnswers: ['mouth', 'in the mouth', 'the mouth'] },
      ],
      finalQuestion: { label: 'Final', question: 'In one word, what do all of these things have in common?', correctAnswers: ['smash', 'smashing'] },
    },
  },
  // screen 5.3  Team up to figure out both weaknesses?
  { type: 'puzzle', label: '5_3',
    blocks: [
      { type: 'text',  value: MSG_PZL_5_3 },
      { type: 'image', src: cmdrbriefs, alt: 'commander briefs' },
    ],
    question: 'What are the two techniques to destroy the Gluteus Grabber 3000?',
    correctAnswer: ['smash and splash', 'smash & splash', 'smash splash', 'smashing and splashing', 'splash and smash', 'splash & smash', 'splashing and smashing', 'splash smash']
  },
  // screen 5.5  Codeword to resume the game after smash
  { type: 'puzzle', label: '5_5',
    heading: 'My only weaknesses, how did you know?',
    blocks: [
      { type: 'text',  value: MSG_CONT_5_5 },
      { type: 'image', src: smashedsplashed, alt: 'Time to Smash & Splash' },
    ],
    question: 'Once you are certain the machine has been disabled, enter the next passphrase here:',
    correctAnswer: ['smashed and splashed', 'smashed & splashed']
  },
  // screen 6  FromSmash
  { type: 'content', label: '6',
    heading: 'Oh Lawd, He Mad!',
    blocks: [
      { type: 'text',  value: MSG_CONT_6_DRBS1 },
      { type: 'image', src: angry, alt: 'Dr. Buttsnatch is not happy' },
    ],
  },
  // screen 7  GoToHQ
  { type: 'puzzle', label: '7',
    heading: 'Well Done, Agents',
    blocks: [
      { type: 'image', src: cmdrbriefs, alt: 'commander briefs' },
      { type: 'text',  value: MSG_CONT_7_HQ },
    ],
    question: 'What\'s your next mission?',
    correctAnswer: 'find his base'
  },
  // [DEPRECATED] screen 8  Codeword to resume the game at hotel
  // { type: 'puzzle', label: '8',
  //     question: 'Enter the code word to confirm you are ready for your next directive.',
  //     correctAnswer: 'codeword'
  //   },
  // screen 9  AtHQ
  { type: 'content', label: '9',
    heading: 'Twin Peaks?',
    blocks: [
      { type: 'image', src: bootybase, alt: 'Dr. Buttsnatchs booty base' },
      { type: 'text',  value: MSG_CONT_9_BASE },
    ],
  },
  // screen 10  FromHQ
  { type: 'puzzle-ab', label: '10',
    A: {
      heading: 'Channel Your Inner Nicholas Cage to Crack the Cryptex',
      blocks: [
        { type: 'image', src: cryptex, alt: 'cryptex' },
        { type: 'text',  value: MSG_PZL_10A },
      ],
      question: 'Where is the Top Secret Booty Base?',     
      correctAnswer: 'the movies' },
    B: {
      heading: 'Fight This Rando NPC',
      blocks: [
        { type: 'text',  value: MSG_PZL_10B },
        { type: 'image', src: mrswiggity, alt: 'mr swiggity swooty' },
        { type: 'text',  value: MSG_PZL_10B2 },
      ],
      question: 'Combining your clue with your partner\'s, what is the location of the Top Secret Booty Base?',     
      correctAnswer: 'the movies' },
  },
  // screen 11  GateMovies
  { type: 'puzzle', label: '11',
     heading: 'Buttsnatch at the Silver Screen?!',
          blocks: [
        { type: 'text',  value: MSG_CONT_11_MOVIES },
        { type: 'image', src: drbs_movies, alt: 'Buttsnatch at the movies?!' },
      ],
    question: 'Report back what happened at the movies, and we will provide your next directive.',
    correctAnswer: 'he got away'
  },
  // screen 12  FromMovies
  { type: 'content-ab', label: '12',
    A: {
      heading: 'He got away?! Well at least things cant get worse... wait... its getting worse?!',
      blocks: [
        {type: 'text', value: MSG_CONT_12_ZOMBIES},
        { type: 'image', src: cmdrbdrat, alt: 'commander briefs frustrated' },
        {type: 'text', value: MSG_CONT_12_ZOMBIES1},
        {type: 'text', value: MSG_CONT_12A_RELAXA},
      ],
    },
      B: {
        heading: 'He got away?! Well at least things cant get worse... wait... its getting worse?!',
        blocks: [
          {type: 'text', value: MSG_CONT_12_ZOMBIES},
          { type: 'image', src: cmdrbdrat, alt: 'commander briefs frustrated' },
          {type: 'text', value: MSG_CONT_12_ZOMBIES1},
          {type: 'text', value: MSG_CONT_12B_RELAXB},
        ],
      },
    },
  // screen 13  Codeword to resume the game after zombies
  // TODO fill this in - A for when you've found the book, B for when done with relaxation hour
  { type: 'puzzle-ab', label: '13',
    A: {
      heading: 'Butt-O-Nomicon could mean anything. What in the heck-a-roo is that thang?',
      // blocks: [
      //   {type: 'text', value: MSG_CONT_14A_REGROUPA},
      // ],
      question: 'After your research mission, enter what you discovered: What IS the Butt-O-Nomicon?',
      correctAnswer: 'book'
    },
    B: { 
      heading: 'Blast Those Butt Zombies!',
      blocks: [
        {type: 'text', value: MSG_PZL_13B},
      ],
      question: 'Once you\'ve spanked the Butt Zombies, report back here for further instructions',
      correctAnswer: ['im ready im ready im ready']
  },
  },
  // screen 14  Regroup
  { type: 'puzzle-ab', label: '14',
    A: { heading: 'An ancient evil book of no-good butt magic... it all adds up!',
      blocks: [
        {type: 'image', src: buttonomicon, alt: 'ancient evil book of buttomancy magic' },
        {type: 'text', value: MSG_CONT_14A_REGROUPA},
      ],
    question: 'Once you\'ve regrouped with your full team, enter the secret password to continue. The secret password is banana.',
    correctAnswer: 'banana'
    },
    B: { heading: 'Thats what you get when you mess with the BUTT WAAAARRIOR!',
    blocks: [
      {type: 'image', src: zombiesdefeated, alt: 'The Butt Zombies are defeated!' },
      {type: 'text', value: MSG_CONT_14B_REGROUPB},
    ],
    question: 'Once you\'ve regrouped with your full team, enter the secret password to continue. The secret password is banana.',
    correctAnswer: 'banana'
  },
},
  // screen 14.5  Pre-Hangman
  {type: 'content', label: '14_5',
    heading: 'What the heck is this?',
    blocks: [
      {type: 'text', value: MSG_CONT_14_5_HANGMAN},
      {type: 'image', src: drawing, alt: 'A mysterious drawing' },
    ],
  },
  // screen 15  Hangman
  { type: 'hangman', label: '15',
    hangmanImages: [hangman1, hangman2, hangman3, hangman4, hangman5, hangman6, hangman7],
    question: 'Guess the right letters to decode this drawing: Where is the Butt-O-Nomicon hidden?',
    correctAnswer: 'if it was up your butt youd know it'
  },
  // screen 16  ToDinner
  { type: 'puzzle', label: '16',
    blocks: [
      {type: 'image', src: cmdrbdrat, alt: 'commander briefs frustrated' },
      {type: 'text', value: MSG_CONT_16_TODINNER},
    ],
    question: 'Are you there yet?',
    correctAnswer: 'yes'
  },
  // screen 17  AtDinner
  { type: 'puzzle-ab', label: '17',
    A: {
       heading: 'Bubble-butt, Bubble-butt, Toil & Trouble-butt',
      blocks: [
        {type: 'text', value: MSG_PZL_17A},
      ],
      question: 'Where is Dr. Buttsnatch going to perform the buttomancy ritual?',
      correctAnswer: 'arcade' 
    },
    B: { 
      heading: 'The Eye of the Tiger',
      blocks: [
        {type: 'text', value: MSG_PZL_17B},
        { type: 'image', src: undieslogo, alt: 'undies logo' },
        {type: 'text', value: MSG_PZL_17B1},
      ],
      question: 'Do you have what it takes?',
      correctAnswer: 'yes' 
    },
  },
  // screen 18 ToArcade
  { type: 'puzzle', label: '18',
    heading: 'To the Arcade! May The Best Butt Win',
    blocks: [
      {type: 'text', value: MSG_CONT_18_TOARCADE},
      {type: 'image', src: arcaderitual, alt: 'dr buttsnatch does evil buttomancy at the arcade' },
    ],
    question: 'Once you have defeated Dr. Buttsnatch and learned his true middle name, enter it here to proceed:',
    correctAnswer: 'Bambiferous'
  },
// screen 19 Conclusion
{ type: 'puzzle', label: '19',    
  heading: 'You Did It! You Saved Our Butts (and All Of The Butts On Earth)!',
  blocks: [
    {type: 'text', value: MSG_CONT_19_COOKIES},
    { type: 'image', src: cmdrbout, alt: 'commander briefs done' },
  ],
  showNext: true,
  question: 'When you arrive at the rewards warehouse, enter its name here to receive your final rewards:',
  correctAnswer: ['insomnia', 'insomnia cookies']
},
{ type: 'carousel', label: '20',
  heading: 'A Message From Your SAMs',
  images: [
    { src: carousel1,        alt: 'carousel 1' },
    { src: carousel2,        alt: 'carousel 2' },
    { src: carousel3,        alt: 'carousel 3' },
    { src: carousel4,        alt: 'carousel 4' },
    { src: carousel5,        alt: 'carousel 5' },
    { src: carousel6,        alt: 'carousel 6' },
    { src: carousel7,        alt: 'carousel 7' },
    { src: carousel8,        alt: 'carousel 8' },
    { src: carousel9,        alt: 'carousel 9' },
  ],
  blocks: [
    {type: 'text', value: MSG_CONT_20_THANKS, className: 'handwritten-note'},
  ],
},
];

const SCREEN_BY_LABEL = Object.fromEntries(
  SCREEN_CONFIG.map((s, i) => [s.label, i])
);

function parseGoParam() {
  const go = new URLSearchParams(window.location.search).get('go');
  if (!go) return null;
  const userMatch = go.match(/([AB])$/i);
  const labelPart = userMatch ? go.slice(0, -1) : go;
  const idx = SCREEN_BY_LABEL[labelPart];
  return idx !== undefined
    ? { screenIndex: idx, currentUser: userMatch ? userMatch[1].toUpperCase() : null }
    : null;
}

function App() {
  const [screenIndex, setScreenIndex] = useState(() => {
    const go = parseGoParam();
    if (go) return go.screenIndex;
    try { return JSON.parse(localStorage.getItem('gameState') || '{}').screenIndex ?? 0; }
    catch { return 0; }
  });

  const [currentUser, setCurrentUser] = useState(() => {
    const go = parseGoParam();
    if (go) return go.currentUser;
    try { return JSON.parse(localStorage.getItem('gameState') || '{}').currentUser ?? null; }
    catch { return null; }
  });

  // Clean URL after using ?go= param so refresh doesn't re-apply it
  useEffect(() => {
    if (parseGoParam()) window.history.replaceState(null, '', window.location.pathname);
  }, []);

  // Save to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem('gameState', JSON.stringify({ screenIndex, currentUser }));
  }, [screenIndex, currentUser]);

  function handleLogin(user) {
    setCurrentUser(user);
    setScreenIndex(2);
  }

  function goBack() {
    if (screenIndex === 2) {
      setCurrentUser(null);
      setScreenIndex(1);
    } else {
      setScreenIndex((i) => i - 1);
    }
  }

  function goNext() {
    setScreenIndex((i) => i + 1);
  }

  function renderScreen() {
    const config = SCREEN_CONFIG[screenIndex];
    if (!config) return null;

    switch (config.type) {
      case 'login':
        return <LoginScreen onLogin={handleLogin} />;

      case 'content':
        return (
          <ContentScreen
            heading={config.heading}
            blocks={config.blocks}
            onBack={goBack}
            onNext={goNext}
            showBack={screenIndex > 0}
            showNext={config.showNext !== false}
          />
        );

      case 'content-ab': {
        const { heading, blocks } = config[currentUser];
        return (
          <ContentScreen
            heading={heading}
            blocks={blocks}
            onBack={goBack}
            onNext={goNext}
            showBack={screenIndex > 0}
          />
        );
      }

      case 'puzzle':
        return (
          <PuzzleScreen
            key={screenIndex}
            heading={config.heading}
            question={config.question}
            correctAnswer={config.correctAnswer}
            blocks={config.blocks}
            onBack={goBack}
            onNext={goNext}
            showBack={screenIndex > 0}
          />
        );

      case 'puzzle-ab': {
        const variant = config[currentUser];
        if (variant.questions) {
          return (
            <TriviaScreen
              heading={variant.heading}
              blocks={variant.blocks}
              questions={variant.questions}
              finalQuestion={variant.finalQuestion}
              onBack={goBack}
              onNext={goNext}
              showBack={screenIndex > 0}
            />
          );
        }
        const { heading, question, correctAnswer, blocks } = variant;
        return (
          <PuzzleScreen
            key={screenIndex}
            heading={heading ?? config.heading}
            question={question}
            correctAnswer={correctAnswer}
            blocks={blocks}
            onBack={goBack}
            onNext={goNext}
            showBack={screenIndex > 0}
          />
        );
      }

      case 'hangman':
        return (
          <HangmanScreen
            blocks={config.blocks}
            hangmanImages={config.hangmanImages}
            question={config.question}
            correctAnswer={config.correctAnswer}
            onBack={goBack}
            onNext={goNext}
            showBack={screenIndex > 0}
          />
        );

      case 'carousel':
        return (
          <CarouselScreen
            heading={config.heading}
            blocks={config.blocks}
            images={config.images}
            interval={config.interval}
            onBack={goBack}
            showBack={screenIndex > 0}
          />
        );

      default:
        return null;
    }
  }

  return <div className="app">{renderScreen()}</div>;
}

export default App;